import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/auth/useAuth';

/**
 * Applies a signed-in user's saved `preferred_language` to the UI. Renders
 * nothing. Because the preference is stored server-side, this makes the chosen
 * language follow the user across devices; anonymous visitors keep the
 * localStorage/browser-detected language instead.
 */
export function LocaleSync() {
  const { user } = useAuth();
  const { i18n } = useTranslation();

  useEffect(() => {
    const preferred = user?.preferred_language;
    if ((preferred === 'en' || preferred === 'fr') && i18n.resolvedLanguage !== preferred) {
      void i18n.changeLanguage(preferred);
    }
  }, [user?.preferred_language, i18n]);

  return null;
}
